import { axiosInstance } from "../lib/axios";
import { HeaderKeys } from "../lib/constants";
import {
  SaveUserAttributesRequest,
  SaveUserAttributesResponse,
} from "../types/api/user-attributes.types";
const BASE_URL = "/webhooks/internal";

export async function saveUserAttributes({
  projectId,
  orgId,
  apiKey,
  conversationIdentifier,
  userAttributes,
}: SaveUserAttributesRequest) {
  const response = await axiosInstance.post<SaveUserAttributesResponse>(
    `${BASE_URL}/set-user-attribute`,
    {
      conversationIdentifier,
      userAttributes,
    },
    {
      headers: {
        [HeaderKeys.apiKey]: apiKey,
        [HeaderKeys.projectId]: projectId,
        [HeaderKeys.organizationId]: orgId,
      },
    },
  );
  return response.data;
}
